import { JobStatusMapKeyLiterals } from '@trukt/portal-utils/JobStatusMap';
import { generatePath } from '@shared/router';
import { PATH_NAMES } from '../../shared/constants/pathNames';

export type JobStatusParamLiterals =
  | 'new'
  | 'tenders'
  | 'on-hold'
  | 'ready'
  | 'in-progress'
  | 'posted'
  | 'requests'
  | 'pending'
  | 'declined'
  | 'dispatched'
  | 'picked-up'
  | 'delivered'
  | 'completed'
  | 'canceled'
  | 'deleted';

const JOB_LIST_VIEW_STATUS_PARAM_MAP: Record<JobStatusMapKeyLiterals, JobStatusParamLiterals> = {
  NEW: 'new',
  TENDER: 'tenders',
  ON_HOLD: 'on-hold',
  READY: 'ready',
  IN_PROGRESS: 'in-progress',
  POSTED: 'posted',
  REQUEST: 'requests',
  PENDING: 'pending',
  DECLINED: 'declined',
  DISPATCHED: 'dispatched',
  PICKED_UP: 'picked-up',
  DELIVERED: 'delivered',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  DELETED: 'deleted',
};

export const JOB_LIST_PATH_NAMES: Record<JobStatusMapKeyLiterals | 'ALL', string> = {
  ALL: PATH_NAMES.ROOT,
  NEW: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.NEW }),
  TENDER: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.TENDER }),
  ON_HOLD: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.ON_HOLD }),
  READY: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.READY }),
  POSTED: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.POSTED }),
  REQUEST: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.REQUEST }),
  PENDING: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.PENDING }),
  DECLINED: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.DECLINED }),
  DISPATCHED: generatePath(PATH_NAMES.jobs.LIST, {
    status: JOB_LIST_VIEW_STATUS_PARAM_MAP.DISPATCHED,
  }),
  PICKED_UP: generatePath(PATH_NAMES.jobs.LIST, {
    status: JOB_LIST_VIEW_STATUS_PARAM_MAP.PICKED_UP,
  }),
  DELIVERED: generatePath(PATH_NAMES.jobs.LIST, {
    status: JOB_LIST_VIEW_STATUS_PARAM_MAP.DELIVERED,
  }),
  COMPLETED: generatePath(PATH_NAMES.jobs.LIST, {
    status: JOB_LIST_VIEW_STATUS_PARAM_MAP.COMPLETED,
  }),
  CANCELED: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.CANCELED }),
  DELETED: generatePath(PATH_NAMES.jobs.LIST, { status: JOB_LIST_VIEW_STATUS_PARAM_MAP.DELETED }),
  IN_PROGRESS: generatePath(PATH_NAMES.jobs.LIST, {
    status: JOB_LIST_VIEW_STATUS_PARAM_MAP.IN_PROGRESS,
  }),
};
